import { render, staticRenderFns } from "./Addressing.vue?vue&type=template&id=c124ede2&"
import script from "./Addressing.vue?vue&type=script&lang=js&"
export * from "./Addressing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports